export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    ME: '/auth/me',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
  },
  USERS: {
    LIST: '/user-management/users',
    /** Admin: per-user cost roll-up (user-based, priced tools only) */
    USER_COSTS: '/user-management/users/costs',
    DETAILS: (userId: string) => `/user-management/${userId}`,
    TOOLS: (userId: string) => `/user-management/${userId}/tools`,
    SET_ROLE: (userId: string) => `/user-management/${userId}/role`,
    SET_APPROVER_STATUS: (userId: string) => `/user-management/${userId}/approver`,
    ALLOWED_DOMAINS: '/user-management/allowed-domains',
  },
  TOOLS: {
    LIST: '/tool-management',
    MY_TOOLS: '/user-management/me/tools',
    ACCESS_IDS: '/tool-management/access-ids',
    DETAILS: (toolId: string) => `/tool-management/${toolId}`,
    CREATE: '/tool-management',
    UPDATE: (toolId: string) => `/tool-management/${toolId}`,
    DELETE: (toolId: string) => `/tool-management/${toolId}`,
    UPLOAD_LOGO: (toolId: string) => `/tool-management/${toolId}/logo`,
    UPLOAD_LOGO_FROM_URL: (toolId: string) => `/tool-management/${toolId}/logo/url`,
    SHARED_CREDENTIALS: (toolId: string) => `/tool-management/${toolId}/shared-credentials`,
    TOOL_REQUESTS: '/tool-management/tool-requests',
    PENDING_TOOL_REQUESTS: '/tool-management/tool-requests/pending',
    MY_TOOL_REQUESTS: '/tool-management/tool-requests/my',
    APPROVE_TOOL_REQUEST: (requestId: string) => `/tool-management/tool-requests/${requestId}/approve`,
    DENY_TOOL_REQUEST: (requestId: string) => `/tool-management/tool-requests/${requestId}/deny`,
    TAGS: '/tool-management/tags',
    COSTS: '/tool-management/costs',
    COSTS_MONTHLY_HISTORY: '/tool-management/costs/monthly-history',
    STATS: '/tool-management/stats',
    RENEWALS: {
      OVERVIEW: '/tool-management/renewals/overview',
      DETAILS: (toolId: string) => `/tool-management/renewals/${toolId}`,
      UPSERT: (toolId: string) => `/tool-management/renewals/${toolId}`,
      DELETE: (toolId: string) => `/tool-management/renewals/${toolId}`,
    },
  },
  CLIENTS: {
    LIST: '/client-management',
    DETAILS: (clientId: string) => `/client-management/${clientId}`,
    CREATE: '/client-management',
    UPDATE: (clientId: string) => `/client-management/${clientId}`,
    DELETE: (clientId: string) => `/client-management/${clientId}`,
    REQUEST_ACCESS: (toolId: string, clientId: string) =>
      `/access-management/request/${toolId}/client/${clientId}`,
    ADMIN_GRANT_ACCESS: (clientId: string, toolId: string) =>
      `/access-management/admin/clients/${clientId}/tools/${toolId}/grant`,
    ADMIN_REVOKE_ACCESS: (clientId: string, toolId: string) =>
      `/access-management/admin/clients/${clientId}/tools/${toolId}/revoke`,
    TOOL_CLIENT_ACCESS_IDS: (toolId: string) =>
      `/access-management/tools/${toolId}/client-access-ids`,
  },
  ACCESS: {
    REQUESTS: '/access-management/requests',
    MY_REQUESTS: '/access-management/me/requests',
    ADMIN_REQUESTS: '/access-management/admin/requests',
    APPROVER_REQUESTS: '/access-management/approver/requests',
    ADMIN_GRANT_ACCESS: (userId: string, toolId: string) => 
      `/access-management/admin/users/${userId}/tools/${toolId}/grant`,
    ADMIN_REVOKE_ACCESS: (userId: string, toolId: string) => 
      `/access-management/admin/users/${userId}/tools/${toolId}/revoke`,
    ADMIN_CANCEL_REQUEST: (requestId: string) => 
      `/access-management/admin/requests/${requestId}/cancel`,
    USER_SELF_REVOKE_ACCESS: (toolId: string) => `/access-management/me/access/${toolId}`,
    REQUEST_BY_ID: (requestId: string) => `/access-management/requests/${requestId}`,
    PROCESS_REQUEST: (requestId: string, action: 'approve' | 'deny') => 
      `/access-management/requests/${requestId}/${action}`,
    MARK_AS_PROCESSED: (requestId: string) => 
      `/access-management/requests/${requestId}/mark-processed`,
  },
}; 